import ReactGA from "react-ga4";

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const initGA = () => {
  if (
    process.env.NODE_ENV === "production" &&
    MEASUREMENT_ID
  ) {
    ReactGA.initialize(MEASUREMENT_ID);
  }
};

export const trackPageView = (path) => {
  if (process.env.NODE_ENV === "production") {
    ReactGA.send({
      hitType: "pageview",
      page: path,
    });
  }
};

export const trackEvent = (category, action, label = "", value = 0) => {
  if (process.env.NODE_ENV === "production") {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  }
};